import React from 'react';
import {useLocation, useRouteMatch} from 'react-router-dom';
import useConfig from 'hooks/use-config';
import {getCanonicalUrl} from 'utils/page-utils';

/**
 * Handles generation of Canonical URL and meta tag based on route path and environment (prod/non-prod).
 *
 * @param {string} previewPagePattern Pattern for matching preview page (optional)
 * @returns {{canonicalURL: string, metaTag: object }} Canonical URL and meta tag (canonical meta tag when non-preview and non-production otherwise robots nofollow).
 */
const useCanonical = (previewPagePattern = '') => {
    const {isProduction, siteUrl} = useConfig();
    const location = useLocation();
    const pageUrl = `${siteUrl}${location.pathname}`;

    // eslint-disable-next-line padding-line-between-statements
    const match = useRouteMatch();
    const isPreviewPage = previewPagePattern
        ? new RegExp(previewPagePattern, 'i').test(match.path)
        : false;

    const isMidFunnelPageUrl =
        match.path.includes(`/city/`) ||
        match.path.includes(`/destination/`) ||
        match.path.includes(`/airport/`);
    const canonicalURL = getCanonicalUrl(pageUrl, isMidFunnelPageUrl);
    const metaTag = <link rel="canonical" href={canonicalURL} />;

    if (isPreviewPage || !isProduction) {
        if (canonicalURL)
            // eslint-disable-next-line no-console
            console.info(`Prod Canonical URL will be: ${canonicalURL}`);

        return {
            canonicalURL: '',
            metaTag: <meta name="robots" content="none" />,
        };
    }

    return {
        canonicalURL,
        metaTag,
    };
};

export default useCanonical;
